module.exports = __webpack_public_path__ + "static/media/ptpos.f156231d.png";